import React, { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";

const FETCH_H2H_GAMEWEEK = gql`
  query ($seasonId: String!, $gameweek: Int!) {
    getH2HGameweek(seasonId: $seasonId, gameweek: $gameweek) {
      Gameweek
      Fixtures {
        Team1Id
        Team1Name
        Team1FplPoints
        Team1H2HPoints
        Team2Id
        Team2Name
        Team2FplPoints
        Team2H2HPoints
      }
    }
  }
`;

function H2HFixtures({ seasonId, gameweek }) {
  const [
    loadData,
    { loading, data: { getH2HGameweek: h2hGameweek } = {}, error },
  ] = useLazyQuery(FETCH_H2H_GAMEWEEK, {
    variables: { seasonId, gameweek },
  });

  useEffect(() => {
    if (seasonId && gameweek) {
      loadData();
    }
  }, [seasonId, gameweek]);

  const isPlayed = (fixture) =>
    fixture.Team1H2HPoints > 0 || fixture.Team2H2HPoints > 0;

  const teamClass = (h2hPoints) => {
    if (h2hPoints === 3) return "h2h-win";
    if (h2hPoints === 1) return "h2h-draw";
    return "h2h-loss";
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Could not load fixtures.</p>;
  if (!h2hGameweek) return <p>Fixtures not yet available for this gameweek.</p>;

  return (
    <table className="h2h-fixtures">
      <tbody>
        {h2hGameweek.Fixtures.map((fixture, index) => {
          const played = isPlayed(fixture);
          return (
            <tr key={index} className="h2h-fixture-row">
              <td
                className={`h2h-team h2h-team-left${
                  played ? ` ${teamClass(fixture.Team1H2HPoints)}` : ""
                }`}
              >
                {fixture.Team1Name}
              </td>
              <td className="h2h-score">
                {played ? fixture.Team1FplPoints : "-"}
              </td>
              <td className="h2h-vs">vs</td>
              <td className="h2h-score">
                {played ? fixture.Team2FplPoints : "-"}
              </td>
              <td
                className={`h2h-team h2h-team-right${
                  played ? ` ${teamClass(fixture.Team2H2HPoints)}` : ""
                }`}
              >
                {fixture.Team2Name}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default H2HFixtures;
